//Common
export const SHOW_LOADER = 'show_loader';
export const HIDE_LOADER = 'hide_loader';
export const SHOW_ERROR = 'show_error';
export const CLEAR_ERROR = 'clear_error';
export const SHOW_MESSAGE = 'show_message';
export const CLEAR_MESSAGE = 'clear_message';
export const OPEN_CONFIRMATION_DIALOG = 'open_confirmation_dialog';
export const CLOSE_CONFIRMATION_DIALOG = 'close_confirmation_dialog';
export const OPEN_TEXT_CONFIRMATION_MODAL = 'open_text_confirmation_modal';
export const CLOSE_TEXT_CONFIRMATION_MODAL = 'close_text_confirmation_modal';
export const OPEN_RENAME_DEVICE_MODAL = 'open_rename_device_modal';
export const CLOSE_RENAME_DEVICE_MODAL = 'close_rename_device_modal';
export const FETCH_COUNTRY_LIST = 'fetch_country_list';
export const FETCH_COUNTRY_LIST_SUCCESS = 'fetch_country_list_success';
export const FETCH_COUNTRY_LIST_ERROR = 'fetch_country_list_error';
export const FETCH_REGION_LIST = 'fetch_region_list';
export const FETCH_REGION_LIST_SUCCESS = 'fetch_region_list_success';
export const FETCH_REGION_LIST_ERROR = 'fetch_region_list_error';
export const FETCH_TIMEZONE_LIST = 'fetch_timezone_list';
export const FETCH_TIMEZONE_LIST_SUCCESS = 'fetch_timezone_list_success';
export const FETCH_TIMEZONE_LIST_ERROR = 'fetch_timezone_list_error';
export const ERROR_MESSAGE_SKIPPED = 'error_message_skipped';
export const DISABLE_API_CACHE = 'disable_api_cache';
export const ENABLE_API_CACHE = 'enable_api_cache';

//Auth
export const SIGNIN_USER = 'signin_user';
export const SIGNIN_USER_SUCCESS = 'signin_user_success';
export const SIGNIN_USER_ERROR = 'signin_user_error';
export const SIGNOUT_USER = 'signout_user';
export const SIGNOUT_USER_SUCCESS = 'signout_user_success';
export const UPDATE_LAST_ACTIVE = 'update_last_active';
export const UPDATE_LAST_ACTIVE_SUCCESS = 'update_last_active_success';
export const UPDATE_AUTH_USER_DATA = 'update_auth_user_data';
export const UPDATE_AUTH_USER_DATA_SUCCESS = 'update_auth_user_data_success';
export const UPDATE_AUTH_USER_DATA_ERROR = 'update_auth_user_data_error';

// USER
export const FETCH_USER = 'fetch_user';
export const FETCH_USER_SUCCESS = 'fetch_user_success';
export const FETCH_USER_ERROR = 'fetch_user_error';
export const CREATE_USER = 'create_user';
export const CREATE_USER_SUCCESS = 'create_user_success';
export const CREATE_USER_ERROR = 'create_user_error';
export const RESEND_USER_INVITE = 'resend_user_invite';
export const RESEND_USER_INVITE_SUCCESS = 'resend_user_invite_success';
export const RESEND_USER_INVITE_ERROR = 'resend_user_invite_error';
export const REVOKE_USER_INVITE = 'revoke_user_invite';
export const REVOKE_USER_INVITE_SUCCESS = 'revoke_user_invite_success';
export const REVOKE_USER_INVITE_ERROR = 'revoke_user_invite_error';
export const FETCH_USER_LIST = 'fetch_user_list';
export const FETCH_USER_LIST_SUCCESS = 'fetch_user_list_success';
export const FETCH_USER_LIST_ERROR = 'fetch_user_list_error';
export const SAVE_USER = 'save_user';
export const SAVE_USER_SUCCESS = 'save_user_success';
export const SAVE_USER_ERROR = 'save_user_error';
export const CLEAR_CURRENT_USER = 'clear_current_user';
export const REMOVE_USER = 'remove_user';
export const REMOVE_USER_SUCCESS = 'remove_user_success';
export const REMOVE_USER_ERROR = 'remove_user_error';
export const UPDATE_USER_SEARCH = 'update_user_search';
export const EDIT_USER_ROLES = 'edit_user_roles';
export const EDIT_USER_ROLES_SUCCESS = 'edit_user_roles_success';
export const EDIT_USER_ROLES_ERROR = 'edit_user_roles_error';
export const ASSIGN_USER_LOCATION_ROLES = 'assign_user_location_roles';
export const ASSIGN_USER_LOCATION_ROLES_SUCCESS = 'assign_user_location_roles_success';
export const ASSIGN_USER_LOCATION_ROLES_ERROR = 'assign_user_location_roles_error';
export const REQUEST_RESET_PASSWORD = 'request_reset_password';
export const REQUEST_RESET_PASSWORD_SUCCESS = 'request_reset_password_success';
export const REQUEST_RESET_PASSWORD_ERROR = 'request_reset_password_error';
export const RESET_PASSWORD = 'reset_password';
export const RESET_PASSWORD_SUCCESS = 'reset_password_success';
export const RESET_PASSWORD_ERROR = 'reset_password_error';
export const VALIDATE_PASSWORD_RESET_TOKEN = 'validate_password_reset_token';
export const VALIDATE_PASSWORD_RESET_TOKEN_SUCCESS = 'validate_password_reset_token_success';
export const VALIDATE_PASSWORD_RESET_TOKEN_ERROR = 'validate_password_reset_token_error';

// REGISTRATION
export const VALIDATE_REGISTRATION_TOKEN = 'validate_registration_token';
export const VALIDATE_REGISTRATION_TOKEN_SUCCESS = 'validate_registration_token_success';
export const VALIDATE_REGISTRATION_TOKEN_ERROR = 'validate_registration_token_error';
export const ACCEPT_INVITATION = 'accept_invitation';
export const ACCEPT_INVITATION_SUCCESS = 'accept_invitation_success';
export const ACCEPT_INVITATION_ERROR = 'accept_invitation_error';

// LOCATIONS
export const FETCH_LOCATIONS = 'fetch_locations';
export const FETCH_LOCATIONS_SUCCESS = 'fetch_locations_success';
export const FETCH_LOCATIONS_ERROR = 'fetch_locations_error';
export const SELECT_ALL_LOCATIONS = 'select_all_locations';
export const SELECT_LOCATION_ROW = 'select_location_row';
export const CREATE_LOCATION = 'create_location';
export const CREATE_LOCATION_SUCCESS = 'create_location_success';
export const CREATE_LOCATION_ERROR = 'create_location_error';
export const FETCH_USER_LOCATIONS = 'fetch_user_locations';
export const FETCH_USER_LOCATIONS_SUCCESS = 'fetch_user_locations_success';
export const FETCH_USER_LOCATIONS_ERROR = 'fetch_user_locations_error';
export const ADD_LOCATIONS_TO_PARENT = 'add_locations_to_parent';
export const ADD_LOCATIONS_TO_PARENT_SUCCESS = 'add_locations_to_parent_success';
export const ADD_LOCATIONS_TO_PARENT_ERROR = 'add_locations_to_parent_error';
export const REMOVE_LOCATIONS = 'remove_locations';
export const REMOVE_LOCATIONS_SUCCESS = 'remove_locations_success';
export const REMOVE_LOCATIONS_ERROR = 'remove_locations_error';
export const UPDATE_LOCATION_SEARCH = 'update_location_search';
export const FETCH_USER_LOCATIONS_ROLES = 'fetch_user_locations_roles';
export const FETCH_USER_LOCATIONS_ROLES_SUCCESS = 'fetch_user_locations_roles_success';
export const FETCH_USER_LOCATIONS_ROLES_ERROR = 'fetch_user_locations_roles_error';
export const UPDATE_LOCATION_FILTERS = 'update_location_filters';
export const SET_CURRENT_LOCATION = 'set_current_location';
export const EDIT_LOCATION = 'edit_location';
export const EDIT_LOCATION_SUCCESS = 'edit_location_success';
export const EDIT_LOCATION_ERROR = 'edit_location_error';
export const SET_LOCATION_SYSTEM_MODE_BULK = 'set_location_system_mode_bulk';
export const SET_LOCATION_SYSTEM_MODE_BULK_SUCCESS = 'set_location_system_mode_bulk_success';
export const INCREMENT_LOCATION_PAGE = 'increment_location_page';
export const REINIT_LOCATION_PAGE_COUNT = 'reinit_location_page_count';
export const FETCH_LOCATIONS_FACETS = 'fetch_locations_facets';
export const FETCH_LOCATIONS_FACETS_SUCCESS = 'fetch_locations_facets_success';
export const FETCH_LOCATIONS_FACETS_ERROR = 'fetch_locations_facets_error';
export const UPDATE_SHOW_LOCATION_FILTERS = 'update_show_location_filters';
export const SET_SINGLE_SELECT_LOCATION = 'set_single_select_location';
export const REMOVE_SINGLE_SELECT_LOCATION = 'remove_single_select_location';
export const CREATE_BULK_UNITS = 'create_bulk_units';
export const CREATE_BULK_UNITS_REQUEST = 'create_bulk_units_request';
export const CREATE_BULK_UNITS_SUCCESS = 'create_bulk_units_success';
export const CREATE_BULK_UNITS_ERROR = 'create_bulk_units_error';

// UNIT
export const FETCH_UNIT_DETAILS = 'fetch_unit_details';
export const FETCH_UNIT_DETAILS_SUCCESS = 'fetch_unit_details_success';
export const FETCH_UNIT_DETAILS_ERROR = 'fetch_unit_details_error';
export const CLEAN_UNIT_DETAILS = 'clean_unit_details';
export const SET_CURRENT_DEVICE = 'set_current_device';
export const REFRESH_UNIT_DETAILS_SUCCESS = 'refresh_unit_details_success';

// REAL TIME
export const REMOVE_DEVICES_FROM_SUBSCRIPTION_MAP = 'remove_devices_from_subscription_map';
export const SUBSCRIBE_DEVICE_DATA = 'subscribe_device_data';
export const UNSUBSCRIBE_DEVICE_DATA = 'unsubscribe_device_data';
export const RECEIVE_DEVICE_REALTIME_DATA = 'receive_device_realtime_data';

// POLLING
export const START_TELEMETRY_POLLING = 'start_telemetry_polling';
export const STOP_TELEMETRY_POLLING = 'stop_telemetry_polling';

// ALERTS
export const FETCH_ALERTS_BY_LOCATION = 'fetch_alerts_by_location';
export const FETCH_ALERTS_BY_LOCATION_SUCCESS = 'fetch_alerts_by_location_success';
export const FETCH_ALERTS_BY_LOCATION_ERROR = 'fetch_alerts_by_location_error';
export const SELECT_ALL_ALERTS = 'select_all_alerts';
export const SELECT_ALERT_ROW = 'select_alert_row';
export const UPDATE_ALERT_SEARCH = 'update_alert_search';
export const FETCH_ALERTS_BY_USER = 'fetch_alerts_by_user';
export const FETCH_ALERTS_BY_USER_SUCCESS = 'fetch_alerts_by_user_success';
export const FETCH_ALERTS_BY_USER_ERROR = 'fetch_alerts_by_user_error';
export const INCREMENT_ALERT_PAGE = 'increment_alert_page';
export const REINIT_ALERT_PAGE_COUNT = 'reinit_alert_page_count';
export const SET_CURRENT_ALERT = 'set_current_alert';
export const CLEAR_ALERT = 'clear_alert';
export const CLEAR_CRITICAL_ALERT= 'clear_critical_alert'; 
export const CLEAR_ALERT_SUCCESS = 'clear_alert_success';
export const CLEAR_ALERT_ERROR = 'clear_alert_error';
export const CLEAR_BULK_ALERTS = 'clear_bulk_alerts';
export const CLEAR_BULK_ALERTS_SUCCESS = 'clear_bulk_alerts_success';
export const CLEAR_BULK_ALERTS_ERROR = 'clear_bulk_alerts_error';
export const UPDATE_ALERT_FILTER = 'update_alert_filter';
export const FETCH_ALARM_LIST = 'fetch_alarm_list';
export const FETCH_ALARM_LIST_SUCCESS = 'fetch_alarm_list_success';
export const FETCH_ALARM_LIST_ERROR = 'fetch_alarm_list_error';
export const FETCH_ALERT_EXPORT_CSV_DATA = 'fetch_alert_export_csv_data';
export const FETCH_ALERT_EXPORT_CSV_DATA_SUCCESS = 'fetch_alert_export_csv_data_success';
export const FETCH_ALERT_EXPORT_CSV_DATA_ERROR = 'fetch_alert_export_csv_data_error';
export const CLEAR_ALERT_EXPORT_CSV_DATA = 'clear_alert_export_csv_data';

// DEVICES
export const CHANGE_VALVE_STATE = 'change_valve_state';
export const CHANGE_VALVE_STATE_SUCCESS = 'change_valve_state_success';
export const CHANGE_VALVE_STATE_ERROR = 'change_valve_state_error';
export const SET_DEVICE_SYSTEM_MODE = 'set_device_system_mode';
export const SET_DEVICE_SYSTEM_MODE_SUCCESS = 'set_device_system_mode_success';
export const SET_DEVICE_SYSTEM_MODE_ERROR = 'set_device_system_mode_error';
export const FETCH_DEVELOPER_MENU_SETTINGS = 'fetch_developer_menu_settings';
export const FETCH_DEVELOPER_MENU_SETTINGS_SUCCESS = 'fetch_developer_menu_settings_success';
export const FETCH_DEVELOPER_MENU_SETTINGS_ERROR = 'fetch_developer_menu_settings_error'
export const UPDATE_DEVELOPER_MENU_SETTINGS = 'update_developer_menu_settings';
export const CHANGE_DEVELOPER_MENU_SETTINGS = 'change_developer_menu_settings';
export const UPDATE_DEVELOPER_MENU_SETTINGS_SUCCESS = 'update_developer_menu_settings_success';
export const UPDATE_DEVELOPER_MENU_SETTINGS_ERROR = 'update_developer_menu_settings_error';
export const UPDATE_DEVICE = 'update_device';
export const UPDATE_DEVICE_SETTINGS = 'update_device_settings';
export const UPDATE_DEVICE_ERROR = 'update_device_error';
export const UPDATE_DEVICE_SUCCESS = 'update_device_success';
export const DELETE_DEVICE = 'delete_device';
export const DELETE_DEVICE_ERROR = 'delete_device_error';
export const DELETE_DEVICE_SUCCESS = 'delete_device_success';
export const RUN_HEALTH_TEST = 'run_health_test';

// SETTINGS
export const FETCH_THRESHOLD_SETTINGS = 'fetch_threshold_settings';
export const FETCH_THRESHOLD_SETTINGS_SUCCESS = 'fetch_threshold_settings_success';
export const FETCH_THRESHOLD_SETTINGS_ERROR = 'fetch_threshold_settings_error';
export const UPDATE_THRESHOLD_SETTINGS = 'update_threshold_settings';
export const SAVE_THRESHOLD_SETTINGS = 'save_threshold_settings';
export const SAVE_THRESHOLD_SETTINGS_SUCCESS = 'save_threshold_settings_success';
export const SAVE_THRESHOLD_SETTINGS_ERROR = 'save_threshold_settings_error';

// AUTO SHUTOFF
export const SAVE_AUTO_SHUTOFF_SETTINGS = 'save_auto_shutoff_settings';

export const SAVE_DEVELOPER_MENU_SETTINGS = 'save_developer_menu_settings';
export const SAVE_DEVELOPER_MENU_SETTINGS_SUCCESS = 'save_developer_menu_settings_success';
export const SAVE_DEVELOPER_MENU_SETTINGS_ERROR = 'save_developer_menu_settings_error';
export const FETCH_NOTIFICATION_SETTINGS = 'fetch_notification_settings';
export const FETCH_NOTIFICATION_SETTINGS_SUCCESS = 'fetch_notification_settings_success';
export const FETCH_NOTIFICATION_SETTINGS_ERROR = 'fetch_notification_settings_error';
export const UPDATE_NOTIFICATION_SETTINGS_TAB = 'update_notification_settings_tab';
export const UPDATE_NOTIFICATION_STATE = 'update_notification_state';
export const SAVE_NOTIFICATION_SETTINGS = 'save_notification_settings';
export const SAVE_NOTIFICATION_SETTINGS_SUCCESS = 'save_notification_settings_success';
export const SAVE_NOTIFICATION_SETTINGS_ERROR = 'save_notification_settings_error';

// CONSUMPTION
export const FETCH_CONSUMPTION_BY_LOCATION = 'fetch_consumption_by_location';
export const FETCH_CONSUMPTION_BY_LOCATION_SUCCESS = 'fetch_consumption_by_location_success';
export const FETCH_CONSUMPTION_BY_LOCATION_ERROR = 'fetch_consumption_by_location_error';
export const CLEAN_CONSUMPTION_DATA = 'clean_consumption_data';
export const FETCH_AREA_TEMPERATURE_BY_LOCATION = 'fetch_area_temperature_by_location';
export const FETCH_AREA_TEMPERATURE_BY_LOCATION_SUCCESS = 'fetch_area_temperature_by_location_success';
export const FETCH_AREA_TEMPERATURE_BY_LOCATION_ERROR = 'fetch_area_temperature_by_location_error';
export const UPDATE_CONSUMPTION_FILTER = 'update_consumption_filter';
export const FETCH_CONSUMPTION_BY_FILTERS = 'fetch_consumption_by_filters';
export const FETCH_CONSUMPTION_BY_FILTERS_SUCCESS = 'fetch_consumption_by_filters_success';
export const FETCH_CONSUMPTION_BY_FILTERS_ERROR = 'fetch_consumption_by_filters_error';

// DASHBOARD
export const FETCH_DASHBOARD_METRICS = 'fetch_dashboard_metrics';
export const FETCH_DASHBOARD_METRICS_SUCCESS = 'fetch_dashboard_metrics_success';
export const FETCH_DASHBOARD_METRICS_ERROR = 'fetch_dashboard_metrics_error';
export const FETCH_DASHBOARD_ALERTS = 'fetch_dashboard_alerts';
export const FETCH_DASHBOARD_ALERTS_SUCCESS = 'fetch_dashboard_alerts_success';
export const FETCH_DASHBOARD_ALERTS_ERROR = 'fetch_dashboard_alerts_error';
export const UPDATE_DASHBOARD_ALERTS = 'update_dashboard_alerts';

// PRESENCE
export const START_PRESENCE_NOTIFICATIONS = 'start_presence_notifications';
export const STOP_PRESENCE_NOTIFICATIONS = 'stop_presence_notifications';
